module.exports = __webpack_public_path__ + "static/media/googleplay.bfdae886.png";